import { bl_inv_outlet_size_hdr_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class InventoryOutletSizeContainerModel extends BaseContainerModel {
  bl_inv_outlet_size_hdr: bl_inv_outlet_size_hdr_RowClass = new bl_inv_outlet_size_hdr_RowClass();
}
